import { T } from '@transifex/react'

import { pathJoin } from '../../../utils'

export const createProductCatalogRouteMap = (prefix: string) => ({
  categories: pathJoin(prefix)('categories').chainWithTitle({
    title: <T _str="Categories" />,
    breadCrumbTitle: <T _str="Categories" />,
  }),
  'categories/:id': (id = ':id') =>
    pathJoin(prefix)(`categories/${id}`).chainWithTitle({
      title: <T _str="Category Detail" />,
      breadCrumbTitle: <T _str="Category Detail" />,
    }),
  'waste-fractions': pathJoin(prefix)('waste-fractions').chainWithTitle({
    title: <T _str="Waste Fractions" />,
    breadCrumbTitle: <T _str="Waste Fractions" />,
  }),
  'pricing-units': pathJoin(prefix)('pricing-units').chainWithTitle({
    title: <T _str="Pricing Units" />,
    breadCrumbTitle: <T _str="Pricing Units" />,
  }),
  products: pathJoin(prefix)('products').chainWithTitle({
    title: <T _str="Products" />,
    breadCrumbTitle: <T _str="Products" />,
  }),
  'products/:id': (id = ':id') =>
    pathJoin(prefix)(`products/${id}`).chainWithTitle({
      title: <T _str="Product Detail" />,
      breadCrumbTitle: <T _str="Product Detail" />,
    }),
  'products/new': pathJoin(prefix)('products')('new').chainWithTitle({
    title: <T _str="Create Product" />,
    breadCrumbTitle: <T _str="Create Product" />,
  }),
  'price-lists/:id': (id = ':id') =>
    pathJoin(prefix)(`price-lists/${id}`).chainWithTitle({
      title: <T _str="Price List Detail" />,
      breadCrumbTitle: <T _str="Price List Detail" />,
    }),
  zones: pathJoin(prefix)('zones').chainWithTitle({
    title: <T _str="Zones" />,
    breadCrumbTitle: <T _str="Zones" />,
  }),
  'price-lists': pathJoin(prefix)('price-lists').chainWithTitle({
    title: <T _str="Price Lists" />,
    breadCrumbTitle: <T _str="Price Lists" />,
  }),
  'service-levels': pathJoin(prefix)('service-levels').chainWithTitle({
    title: <T _str="Service Levels" />,
    breadCrumbTitle: <T _str="Service Levels" />,
  }),
  'bill-of-materials': pathJoin(prefix)('bill-of-materials').chainWithTitle({
    title: <T _str="Bill of Materials" />,
    breadCrumbTitle: <T _str="Bill of Materials" />,
  }),
  'audit-logs': pathJoin(prefix)('audit-logs').chainWithTitle({
    title: <T _str="Audit Logs" />,
    breadCrumbTitle: <T _str="Audit Logs" />,
  }),
})
